module.exports = __webpack_public_path__ + "img/agent.c10e6eff.svg";